import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';
import { queryClient } from 'src/core/react-query';

export interface UseUpdatePhoneVariables {
  userId: number;
  phone: string;
}

export interface UseUpdatePhoneData {
  phone: string;
}

export interface UseUpdatePhoneErrorData {
  phone: Array<string>;
}

export function useUpdatePhone() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseUpdatePhoneData,
    AxiosError<UseUpdatePhoneErrorData>,
    UseUpdatePhoneVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .put<UseUpdatePhoneData>(
          `/posht/ashena/users/${data.userId}/set-phone/`,
          {
            phone: data.phone,
          },
        )
        .then((res) => res.data);
    },
    {
      onError: (error) => {
        if (error.response?.status === 400) {
          enqueueSnackbar(error.response.data.phone[0], {
            variant: 'error',
          });
        } else {
          enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
        }
      },
      onSettled: (data, error, variables, context) => {
        const userId = parseInt(String(variables.userId));
        queryClient.invalidateQueries(['user', userId]);
        queryClient.invalidateQueries('users');
      },
      onSuccess: () => {
        enqueueSnackbar(t('profile.phoneChangedSuccessfully'), {
          variant: 'success',
        });
      },
    },
  );
}
